import SVG from "commons/styles/svgIcon";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const StBtn = styled.button<{ showTopBtn: boolean }>`
  position: fixed;
  bottom: 90px;
  right: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 14pxs;
  width: 45px;
  height: 45px;
  /* background-color: #fff; */
  background-color: var(--secondary);
  border: 1px solid var(--secondary);
  border-radius: 25px;
  box-shadow: 3px 3px 6px #8e8e8e;
  opacity: ${props => (props.showTopBtn ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  z-index: 10;
  cursor: ${props => (props.showTopBtn ? "pointer" : "auto")};
  pointer-events: ${props => !props.showTopBtn && "none"};

  &::after {
    display: block;
    width: 30px;
    height: 30px;
    background: url(${SVG.DownArrow("#fff")}) no-repeat center center;
    background-size: 30px;
    transform: rotate(180deg);
    content: "";
  }
`;
const ScrollTop = () => {
  const location = useLocation();
  const [showTopBtn, setShowTopBtn] = useState<boolean>(false);
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  return <StBtn onClick={goToTop} showTopBtn={showTopBtn}></StBtn>;
};

export default React.memo(ScrollTop);
